"use strict";
/**
 * Created by Marvin on 07.07.17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var redux_form_1 = require("redux-form");
var react_redux_1 = require("react-redux");
var actions_1 = require("../actions");
var helpers_1 = require("../helpers");
// @ts-ignore
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var SimpleForm = /** @class */ (function (_super) {
    __extends(SimpleForm, _super);
    function SimpleForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleForm.prototype.componentDidMount = function () {
        typeof this.props.asyncValidate === 'function' ? this.props.asyncValidate() : null;
    };
    SimpleForm.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.form !== nextProps.form && typeof nextProps.asyncValidate === 'function') {
            nextProps.asyncValidate();
        }
    };
    SimpleForm.prototype.render = function () {
        return (react_1["default"].createElement("form", { onSubmit: this.props.handleSubmit(this.props.onSubmit) }, this.props.children));
    };
    return SimpleForm;
}(react_1["default"].Component));
var FormWrapper = /** @class */ (function (_super) {
    __extends(FormWrapper, _super);
    function FormWrapper(props) {
        var _this = _super.call(this, props) || this;
        // @ts-ignore
        _this.container = (0, redux_form_1.reduxForm)({})(SimpleForm);
        return _this;
    }
    FormWrapper.prototype.render = function () {
        return react_1["default"].createElement(this.container, __assign({}, this.props));
    };
    return FormWrapper;
}(react_1["default"].Component));
function mapState(state, _a) {
    var name = _a.name, checkUrl = _a.checkUrl, initialValues = _a.initialValues;
    return {
        form: name,
        formValues: (0, find_in_object_1["default"])('form.' + name + '.values', state),
        initialValues: Object.assign({}, (0, helpers_1.initialValuesFromURL)(name), initialValues),
        asyncValidate: checkUrl ? (0, actions_1.asyncValidate)({ name: name, url: checkUrl }) : false,
        onChange: checkUrl ? (0, actions_1.asyncValidate)({ name: name, url: checkUrl }) : false
    };
}
// @ts-ignore
var ConnectedFormWrapper = (0, react_redux_1.connect)(mapState)(FormWrapper);
exports["default"] = ConnectedFormWrapper;
